import { Stack, Switch, Typography } from "@mui/material";
import React from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { getLinearSettings } from "../../../../viewer/chart/helper.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings, ValueAxis } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  axis: ValueAxis;
  settings: ChartStyleSettings;
  readonlyMode: boolean;
}

export default function ShowLabelItem({ axis, settings, readonlyMode }: Props) {
  const showLabel = React.useMemo(() => isShowValueAxisLabel(settings, axis.name), [settings, axis]);
  const dispatch = useAppDispatch();

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Show Label</Typography>
      <HorizontalFill />
      <Switch
        checked={showLabel}
        disabled={readonlyMode}
        onChange={(_, value) =>
          dispatch(fieldsStateActions.updateAxisValueSettings({ name: axis.name, changes: { showLabel: value } }))
        }
      />
    </Stack>
  );
}

function isShowValueAxisLabel(settings: ChartStyleSettings, name: string) {
  return getLinearSettings(settings)?.valueAxis?.find((va) => va.name === name)?.showLabel !== false;
}
